import * as z from 'zod';

export const PublicApiConfigSchema = z.object({
  baseUrl: z.string().nonempty(),
});

export type PublicApiConfig = z.infer<typeof PublicApiConfigSchema>;

const rawBaseUrl: string = import.meta.env.APP_CLIENT_WEB_PUBLIC_API_BASE_URL!;
const normalizedBaseUrl =
  rawBaseUrl && !/^https?:\/\//i.test(rawBaseUrl)
    ? `http://${rawBaseUrl}`
    : rawBaseUrl;

export const publicApiConfig = Object.freeze(
  PublicApiConfigSchema.parse({
    baseUrl: normalizedBaseUrl,
  }),
);
